import { Descriptions } from "@/components/v2";
import { type DescriptionsProps } from "antd";
import { Company } from "@rumble-it/common-lib/types/models/Company.interface";
import { getMapsLink } from "@/lib/helpers/links";
import { Card } from "@rumbledirect/ui";

interface InsuranceCompanyCardProps {
  insuranceCompany: Company | undefined;
  isLoading?: boolean;
}

export const InsuranceCompanyCard = ({
  insuranceCompany,
  isLoading,
}: InsuranceCompanyCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Bedrijfsnaam",
      children: insuranceCompany?.fullName,
    },
    {
      label: "Groep",
      children: insuranceCompany?.groupName,
    },
    {
      label: "Type",
      children: insuranceCompany?.type,
    },
    {
      label: "E-mail",
      children: insuranceCompany?.email ? (
        <a href={`mailto:${insuranceCompany.email}`}>
          {insuranceCompany.email}
        </a>
      ) : null,
    },
    {
      label: "Telefoon",
      children: insuranceCompany?.telephone ? (
        <a href={`tel:${insuranceCompany.telephone}`}>
          {insuranceCompany.telephone}
        </a>
      ) : null,
    },
    {
      label: "Adres",
      children: insuranceCompany?.address ? (
        <>
          <a
            href={getMapsLink({ address: insuranceCompany.address })}
            target="_blank"
            rel="noopener noreferrer"
          >
            {`${insuranceCompany.address.street} ${insuranceCompany.address.streetNumber}${insuranceCompany.address.streetNumberAddition || ""}`}{" "}
            <br />
            {insuranceCompany.address.postalCode}{" "}
            {insuranceCompany.address.city}{" "}
            {insuranceCompany.address.country ? (
              <>
                <br />
                {insuranceCompany.address.country}
              </>
            ) : null}
          </a>
        </>
      ) : null,
    },
  ];

  // Don't render the card if there's no insurance company data
  if (!insuranceCompany) {
    return null;
  }

  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Verzekeringsmaatschappij"
    >
      <Descriptions items={items} />
    </Card>
  );
};
